export default {
  loading: {
    id: 'spinner',
    defaultMessage: 'Loading',
  },
  productThumbStartingFrom: {
    id: 'product_thumb_starting_from',
    defaultMessage: 'Starting from',
  },
  productThumbCondition: {
    id: 'product_thumb_condition',
    defaultMessage: 'Condition: {grade}',
  },
  pthumbsWarrantyNew: {
    id: 'pthumbs_warranty_new',
    defaultMessage: 'Warranty: {warranty}',
  },
}
